import React, { useEffect, useState } from "react";
import { Bar, Line } from 'react-chartjs-2';
import { Button } from 'antd';
import { SwapOutlined } from '@ant-design/icons';


const Chart_1 = ({wholeData }) => {
// const [date_list, setDate_list] = React.useState([]);
// const [dailyconfirmed_list, setDailyconfirmed_list] = React.useState([]);
// const [dailyrecovered_list, setDailyrecovered_list] = React.useState([]);
// const [dailydeceased_list, setDailydeceased_list] = React.useState([]);
const [chartData, setChartData] = React.useState({});
const [chartValue, setChartValue] = React.useState("L");


 function getChartData(){
  var time_Series = wholeData["cases_time_series"]
  var date_list = []
  var date_ymd_list = []
  var dailyconfirmed_list = []
  var dailydeceased_list = []
  var dailyrecovered_list = []
  var totalconfirmed_list = []
  var totaldeceased_list = []
  var totalrecovered_list = []


  // for (var key in time_Series) {
  //   console.log("key : ",key)
  //   key = key + 10
  // }

  for (var i=1; i<=time_Series.length; i = i + 1)  
    {  
      // console.log("key : ",i);
      if (true)  {
        try{
            date_list.push(time_Series[i]["date"])
            date_ymd_list.push(time_Series[i]["dateymd"])
            dailyconfirmed_list.push(parseInt(time_Series[i]["dailyconfirmed"]))
            dailyrecovered_list.push(parseInt(time_Series[i]["dailyrecovered"]))
            dailydeceased_list.push(parseInt(time_Series[i]["dailydeceased"]))

            // totalconfirmed_list.push(parseInt(time_Series[i]["totalconfirmed"]))
            // totalrecovered_list.push(parseInt(time_Series[i]["totalrecovered"]))
            // totaldeceased_list.push(parseInt(time_Series[i]["totaldeceased"]))
        }
        catch(err){
          // console.log("catch : ",err)
          ;
        }
      }
    }  

  // console.log(" date_list : ", date_list)
  // console.log(" date_ymd_list : ", date_ymd_list)
  // console.log(" dailyconfirmed_list : ", dailyconfirmed_list)
  // console.log(" dailyrecovered_list : ", dailyrecovered_list)
  // console.log(" dailydeceased_list : ", dailydeceased_list)
  // console.log(" totalconfirmed_list : ", totalconfirmed_list)
  // console.log(" totalrecovered_list : ", totalrecovered_list)
  // console.log(" totaldeceased_list : ", totaldeceased_list)

  // setDate_list(date_list)
  // setDailyconfirmed_list(dailyconfirmed_list)
  // setDailyrecovered_list(dailyrecovered_list)
  // setDailydeceased_list(dailydeceased_list)

  loadChartData(date_list , dailyconfirmed_list, dailyrecovered_list, dailydeceased_list)
 }

 function loadChartData(date_list , dailyconfirmed_list, dailyrecovered_list, dailydeceased_list) {

   var tmpData = {
    labels: date_list,
    datasets: [
      {
        label: 'Confirmed',
        data: dailyconfirmed_list,
        backgroundColor: '#1E88E5',
      },
      {
        label: 'Recovered',
        data: dailyrecovered_list,
        backgroundColor: '#00E676',

      },
      {
        label: 'Deceased',
        data: dailydeceased_list,
        backgroundColor: '#F44336',

      },
    ],
  };

  setChartData(tmpData)
 }


const options = {
  indexAxis: 'x',
  // Elements options apply to all of the options unless overridden in a dataset
  // In this case, we are setting the border of each horizontal bar to be 2px wide
  elements: {
    bar: {
      borderWidth: 1,
    },
  },
  responsive: true,
  plugins: {
    legend: {
      position: 'right',
    },
    title: {
      display: true,
      text: 'Coronavirus live data',
    },
  },
};

  function handleToggle(){
    // console.log("Toggle chartValue",chartValue)
    if(chartValue == "B"){
      setChartValue("L")
    }
    else{
      setChartValue("B")
    }
  }

  function onChange(checkedValues) {
    console.log('checked = ', checkedValues);
  }

  useEffect(() => {
    getChartData()
    // console.log("wholeData : ",wholeData)
  }, []); // <-- Have to pass in [] here!


  return (
    <div>
        <div className='header'>
          <h1 className='title' style={{float:"left"}}>Covid realtime chart</h1>
          <Button type="default" icon={<SwapOutlined />} size={'large'} onClick={handleToggle} style={{float:"right"}}>
                Toggle Chart
          </Button>

        </div>
        { chartValue == "B" ?
            <Bar data={chartData} options={options} style={{height:"120%"}}/>
             :
            <Line data={chartData} options={options} style={{height:"120%"}}/>
        }   

    </div>
  );
}

export default Chart_1;
